export enum AppNotifications {
  CreditNotEnough = 'برای انجام عملیات، اعتبار شما کافی نمی‌باشد',
  RetryOperation = 'RetryOperation',
  DowngradePlanIsNotPermitted = "خرید این پلن برای شما امکان پذیر نیست. لطفا پلن دیگری را انتخاب کنید.",
  RefreshTokenNotFound = 'رفرش توکن یافت نشد',
  PasswordNotMatch = 'پسورد های وارد شده با هم یکسان نمی‌باشد.',
  VerificationCodeSent = 'کد به شماره همراه وارد شده ارسال شد.',
  VerificationCodeAlreadySent = 'از آخرین کد ارسالی استفاده کنید.',
  ContactsAdded = 'مخاطبان با موفقیت به سامانه اضافه شدند.',
  ImageSizeInvalid = 'سایز عکس بیشتر از مقدار مجاز است.',
  UploadedFileSizeError = 'سایز فایل انتخابی بیشتر از حد مجاز می‌باشد.',
  UploadedFileFormatIncorrect = 'فرمت فایل انتخابی قابل قبول نیست.',
  BusinessLogoMustBe1024Jpg = 'تصویر لوگو با حداکثر ابعاد 1024×1024 پیکسل آپلود شود.',
  PasswordChangeSuccess = 'تغییر پسورد با موفقیت انجام شد.',
  EventCreated = 'رویداد با موفقیت به سامانه اضافه شد.',
  UploadedSuccessfully = 'فایل مورد نظر با موفقیت بارگزاری شد.',
  ChangesSaved = 'تغییرات با موفقیت ذخیره شد.',
  EventDeleted = 'رویداد مورد نظر حذف شد.',
  GroupNameChanged = 'نام گروه با موفقیت تغییر یافت.',
  GroupDeleted = 'گروه مورد نظر حذف شد.',
  GroupCreated = 'گروه با موفقیت ایجاد شد.',
  DeviceCreated = 'اپلیکیشن با موفقیت ایجاد شد.',
  DeviceConnected = 'اپلیکیشن با موفقیت متصل شد.',
  IpAddedSuccessfully = 'آی پی با موفقیت اضافه گردید.',
  LoginAgain = 'لطفا مجدد وارد حساب کاربری خود شوید.',
  UnknownError = 'خطایی در سامانه رخ داده است.',
  TooManyRequests = 'تعداد درخواست‌های ارسالی بیش از حد مجاز است. لطفاً پس از مدتی مجدداً تلاش نمایید.',
  NoAccess = 'متأسفانه شما اجازه دسترسی به این بخش را ندارید.',
  RequestSuccess = 'درخواست با موفقیت ثبت شد.',
  NoUserLines = 'هیچ خطی یافت نشد.',
  NoUserLinesAllowSending = 'هیچ خطی برای ارسال یافت نشد.',
  InvalidMobile = 'شماره موبایل معتبر نیست.',
  MinPolygonVertices = 'چندضلعی باید حداقل ۴ رأس داشته باشد.',
  MinCircleRadius = 'شعاع نمی‌تواند کمتر از ۵۰ متر باشد.',
  MaxCircleRadius = 'شعاع نمی‌تواند بیشتر از ۱۰،۰۰۰ متر باشد.',
  coordinatesRequired = 'برای ادامه، لطفاً مختصات دقیق محدوده خود را وارد نمایید.',
  SmartZoneDeleted = 'ارسال مورد نظر حذف شد.',
  MessengerDeleted = 'ارسال مورد نظر حذف شد.',
  MessengerBotDraftInProgress = 'یک درخواست ساخت بازو در جریان دارید. ابتدا آن را تکمیل کنید.',
  MessengerSendDraftInProgress = 'یک درخواست ارسال ناتمام دارید. ابتدا آن را تکمیل یا حذف کنید.',
  SmartZonePastDisabled = 'در حال حاضر قابلیت ارسال درخواست‌های جدید در دسترس نیست.',
  InvalidClosedPolygon= 'محدوده ترسیم‌شده معتبر نیست. لطفاً محدوده را بسته و بدون تقاطع رسم کنید.',
  InvalidEdgeLimitation= 'محدوده ترسیم‌شده معتبر نیست. برخی از اضلاع طولی بیشتر از ۴ کیلومتر دارند.',
  PleaseEnterText='لطفا متن را وارد کنید',
  Copy='متن کپی شد',
  DiscountCodeAddedSuccessfully = 'کد تخفیف با موفقیت اعمال شد.',
  DiscountCodeRemoved = 'کد تخفیف مورد نظر حذف  شد.',
  GiftCodeAddedSuccessfully = 'کارت هدیه با موفقیت اعمال شد.',
  GiftCodeRemoved = 'کارت هدیه مورد نظر حذف شد.',
  GiftCodeIsNotGift = 'این کد کارت هدیه نیست. از بخش کد تخفیف استفاده کنید.',
  DiscountCodeIsGift = 'این کد تخفیف نیست. از بخش کارت هدیه استفاده کنید.',
  ReceiptFileRequired = 'آپلود تصویر فیش واریزی الزامی است.',

}
